// src/App.js
import Navigation from "./components/Navigation/navigation";
import Sections from "./components/Sections/sections";

function App() {
  return (
    <>
      <Navigation />
      <Sections />
    </>
  );
}
export default App;
